import { PairingProvider, usePairing } from "../hooks/usePairing";
import LoadingContainer from "./LoadingConitainer";
import PairingPinContainer from "./PairingPinContainer";

const PairingScreen = () => {
  return (
    <PairingProvider>
      <PairingScreenPresenter />
    </PairingProvider>
  );
};

function PairingScreenPresenter() {
  const { randomPin } = usePairing();
  return (
    <div className="h-full w-full bg-zinc-900">
      {randomPin ? (
        <PairingPinContainer
          key={`pin_screen_${randomPin}`}
          randomPin={randomPin}
        />
      ) : (
        <LoadingContainer />
      )}
    </div>
  );
}

export default PairingScreen;
